<template>
  <confirm-dialog
    :value="confirmDialog"
    title="ブラウザに一時保存されたデータがあります"
    ok-text="クラウドデータから再読込"
    cancel-text="キャンセル"
    other-text="ブラウザデータから再開"
    :max-width="550"
    @ok="onClearSessionClicked"
    @cancel="$emit('cancel')"
    @other="onContinueSessionClicked"
    @input="$emit('close')">
    <div class="pt-3 pl-5 pb-3">
      <div class="d-flex">
        <span>案件名:</span>
        <h4>{{ dataTitle }}</h4>
      </div>
      <div class="d-flex">
        <span>保存時間:</span>
        <h4>{{ dataDate }}</h4>
      </div>
    </div>
    <v-card-text>
      ブラウザに保存されたデータから再開するか、クラウド上のデータを再読込して編集するか選択してください。<br />
      <strong>
        クラウド上のデータから再読込するとブラウザに一時保存されたデータは削除されます。
      </strong>
    </v-card-text>
  </confirm-dialog>
</template>

<script>
import ConfirmDialog from './ConfirmDialog'
import {
  getLastUnsavedSessionDate,
  getStepObjectId,
  getStepSession,
  removeAllStepSession,
} from '../logic/session'

export default {
  name: 'UnsavedSessionConfirm',
  components: { ConfirmDialog },
  props: {
    confirmDialog: {
      type: Boolean,
      default: true,
    },
    sessionName: {
      type: String,
      require: true,
      default: '',
    },
    routeNameNew: {
      type: String,
      require: true,
      default: '',
    },
    routeNameContinue: {
      type: String,
      require: true,
      default: '',
    },
  },
  computed: {
    dataTitle() {
      const session = getStepSession(
        this.sessionName,
        this.sessionName === 'written-survey' || this.sessionName === 'report'
          ? 2
          : 1,
      )
      return session ? session.title : ''
    },
    dataDate() {
      return getLastUnsavedSessionDate(this.sessionName)
    },
  },
  methods: {
    // ダイアログ 削除して進むボタン
    onClearSessionClicked() {
      removeAllStepSession(this.sessionName)
      if (this.routeNameNew) {
        this.$router.push({ name: this.routeNameNew })
      }
      this.$emit('clear')
    },
    // ダイアログ 復元するボタン
    onContinueSessionClicked() {
      this.$emit('continue')
      if (this.routeNameContinue) {
        const id = getStepObjectId(this.sessionName)
        this.$router.push({ name: this.routeNameContinue, params: { id } })
      }
    },
  },
}
</script>

<style scoped>

</style>
